<aside class="addremove-action">
  <app-chip-list-autocomplete [valueControl]="valueControl"></app-chip-list-autocomplete>
</aside>
